export const headCopy = {
  head_playground_title:
    "Playground TS - Un éditeur en ligne pour explorer TypeScript et JavaScript",
  head_playground_description:
    "Le playground vous permet d'écrire du TypeScript ou du JavaScript en ligne de manière sûre et partageable.",
  tsconfig_title: "Référence TSConfig - documentation sur toutes les options du fichier TSConfig",
  tsconfig_description:
    "De allowJs à useDefineForClassFields, la référence TSConfig documente les différents options du compilateur qui permettent de configurer un projet TypeScript.",
  playground_example_prefix: "Playground Exemple - ",

  head_index_title: "JavaScript typé à toute échelle",
  head_index_description: "JavaScript typé à toute échelle",
};
